import React from "react";
import { Edit as RaEdit } from "react-admin";
import { useFormStyles } from "../components/forms/useStyles";
import Title from "../components/Title";
import Form from "./Form";
import { transform } from "./transform";

const Edit = (props) => {
	const classes = useFormStyles();
	return (
		<RaEdit
			{...props}
			mutationMode="pessimistic"
			classes={classes}
			title={<Title source="title" />}
			transform={transform}
		>
			<Form />
		</RaEdit>
	);
};
export default Edit;
